import {
    BooleanInputConfig,
    CodelistInputConfig,
    DateInputConfig,
    DateRangeInputConfig,
    DateTimeInputConfig,
    EditorInputConfig,
    FileInputConfig,
    InputConfig,
    InputType,
    NumberInputConfig,
    SelectInputConfig,
    TextareaInputConfig
} from './input.type';

export const formatCharacterCount = (maxLength: number, value: string) => {
    if (maxLength) {
        return `${value?.length ?? 0} / ${maxLength}`;
    }
    return null;
};

/**
 * Generates InputConfig for component app-input based on FormProperty
 * @param property - The FormProperty to generate config for
 * @returns InputConfig matching the property type
 */
export function generateInputConfig(property: InputConfig, isEditMode: boolean = true): InputConfig {
    const baseConfig = {
        isEditMode,
        labelPosition: 'top',
        ...property
    } as InputConfig;

    switch (property.type) {
        case InputType.TEXT:
            return {
                ...baseConfig,
                maxLength: property.maxLength || 255
            } as TextareaInputConfig;
        case InputType.TEXTAREA:
            return {
                ...baseConfig,
                maxLength: property.maxLength || 255,
                rows: property.rows || 3
            } as TextareaInputConfig;
        case InputType.NUMBER:
            return {
                ...baseConfig,
                min: property.min || 0,
                format: property.format || '#',
                decimals: property.decimals || 0
            } as NumberInputConfig;
        case InputType.BOOLEAN:
            return {
                ...baseConfig
            } as BooleanInputConfig;
        case InputType.DATE:
            return {
                ...baseConfig,
                formatPlaceholder: property.formatPlaceholder || this.dateFormatPlaceholder
            } as DateInputConfig;
        case InputType.DATETIME:
            return {
                ...baseConfig,
                formatPlaceholder: property.formatPlaceholder || this.dateFormatPlaceholder
            } as DateTimeInputConfig;
        case InputType.DATERANGE:
            return {
                ...baseConfig,
                formatPlaceholder: property.formatPlaceholder || this.dateFormatPlaceholder
            } as DateRangeInputConfig;
        case InputType.TIME:
            return {
                ...baseConfig,
                formatPlaceholder: property.formatPlaceholder
            } as DateTimeInputConfig;
        case InputType.FILE:
            return {
                ...baseConfig,
                showFileList: true,
                restrictions: property.restrictions || this.fileRestrictions
            } as FileInputConfig;
        case InputType.SELECT:
            return {
                ...baseConfig,
                valuePrimitive: true,
                popupSettings: property.popupSettings || this.popupSettings,
                textField: 'label',
                valueField: 'value'
            } as SelectInputConfig;
        case InputType.CODELIST:
            return {
                ...baseConfig,
                popupSettings: property.popupSettings || this.popupSettings,
                textField: 'label',
                valueField: 'value'
            } as CodelistInputConfig;
        case InputType.EDITOR:
            return {
                ...baseConfig
            } as EditorInputConfig;
    }
}

export function getInputName(property: InputConfig): string {
    return property.id;
}
